import { I18nThemed } from 'interfaces/mixins';
import { DNode } from '@dojo/framework/core/interfaces';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';

import { FormLabelField } from '../interfaces';
import css from '../css/form.m.css';

export interface FormLabelProperties extends FormLabelField {}

@theme(css)
export class FormLabel extends I18nThemed<FormLabelProperties> {
	protected render(): DNode {
		const { title } = this.properties;
		return v('div', { classes: [this.theme(css.formLabel)] }, [v('label', {}, [title])]);
	}
}
